import { useMutation } from "@apollo/client";
import { graphql } from "../gql";
import { GetAllProgressCheckPdfsQuery } from "./useAllProgressCheckPdfs.ts";
import { SpeakingClassLevel } from "../gql/graphql.ts";

const UpsertProgressCheckPdfMutation = graphql(`
  mutation upsertProgressCheckPdf(
    $level: SpeakingClassLevel!
    $pdfUrl: String!
    $userGroupId: String!
  ) {
    upsertProgressCheckPdf(
      level: $level
      pdfUrl: $pdfUrl
      userGroupId: $userGroupId
    )
  }
`);

export function useUpsertProgressCheckPdf() {
  const [mutate, { loading }] = useMutation(UpsertProgressCheckPdfMutation, {
    refetchQueries: [GetAllProgressCheckPdfsQuery],
  });

  return {
    loading,
    upsert: (input: {
      level: SpeakingClassLevel;
      pdfUrl: string;
      userGroupId: string;
    }) =>
      mutate({
        variables: input,
      }),
  };
}
